export default {
  mounted(el, binding) {
    const placeholder = binding.value || '/img/placeholder.png';

    el.onerror = () => {
      el.src = placeholder;
    };
  },
};
